export const DATE_PICKER_FILTER = 'date-picker-filter';
export const REGIONAL_RISK_SWITCHER = 'regional-risk-switcher';
export const REGIONAL_RISK_RE_CENTER_BUTTON_CONTAINER = 'regional-risk-re-center-button-container';
export const REGIONAL_RISK_LEGEND_RISK_CONTAINER = 'regional-risk-legend-risk-container';

export const REGIONAL_RISK_DISEASE_TAG = 'disease-tag';
export const REGIONAL_RISK_DISEASE_TAG_ICON = 'disease-tag-icon';
export const REGIONAL_RISK_DISEASE_TAG_NAME = 'disease-tag-name';

export const REGIONAL_RISK_ABIOTIC_STRESS_TAG = 'abiotic-stress-tag';
export const REGIONAL_RISK_ABIOTIC_STRESS_TAG_NAME = 'abiotic-stress-tag-name';
export const REGIONAL_RISK_ABIOTIC_STRESS_ALERT = 'regional-risk-abiotic-stress-alert';

export const ABIOTIC_STRESS_SECTION_DIVIDER = 'abiotic-stress-section-divider';
export const ABIOTIC_STRESS_SECTION_LABEL = 'abiotic-stress-section-label';
export const ABIOTIC_STRESS_SECTION_WRAPPER = 'abiotic-stress-section-wrapper';

export const RISK_LEVEL_CONTAINER = 'risk-level-container';
export const RISK_LEVEL_HEADER = 'risk-level-header';
export const RISK_LEVEL_LABEL = 'risk-level-label';
export const RISK_LEVEL_FARM_COUNT = 'risk-level-farm-count';
export const RISK_LEVEL_ARROW = 'risk-level-arrow';
export const RISK_LEVEL_CONTENT = 'risk-level-content';
export const RISK_LEVEL_WARNING_ICON = 'risk-level-warning-icon';
export const RISK_LEVEL_CHECK_ICON = 'risk-level-check-icon';
export const RISK_LEVEL_QUESTION_ICON = 'risk-level-question-icon';

export const FIELD_CARD_CONTAINER = 'field-card-container';
export const FIELD_CARD_TITLE = 'field-card-title';
export const FIELD_CARD_BBCH = 'field-card-bbch';
export const FIELD_CARD_AREA = 'field-card-area';
export const FIELD_CARD_VARIETY = 'field-card-variety';
export const FIELD_CARD_DISEASES = 'field-card-diseases';

export const INOCULUM_CONTAIER = 'inoculum-survival-containe';
export const INOCULUM_LOADING = 'inoculum-survival-loading';

export const STATISTICS_LIST_CONTAINER = 'statistics-list-container';

export const MOCKED_DATA_ALERT_CONTAINER = 'mocked-data-alert-container';

export const FILTERS_COMPONENT_CONTAINER = 'filters-component-container';
export const FILTERS_COMPONENT_PANEL = 'filters-component-panel';
export const FILTERS_COMPONENT_RISK_LEVEL = 'filters-component-risk-level';
export const FILTERS_COMPONENT_CROPS = 'filters-component-crops';
export const FILTERS_COMPONENT_TECHNICIAN = 'filters-component-technician';
export const FILTERS_COMPONENT_GROWTH_STAGES = 'filters-component-growth-stages';
export const FILTERS_COMPONENT_VARIETY = 'filters-component-variety';
export const FILTERS_COMPONENT_DISEASE = 'filters-component-disease';
export const FILTERS_COMPONENT_SOWING_DATE = 'filters-component-sowing-date';
export const FILTERS_COMPONENT_ZONES = 'filters-component-zones';
export const FILTERS_COMPONENT_PREVIOUS_CROP = 'filters-component-previous-crop';
export const FILTERS_COMPONENT_TILLAGE = 'filters-component-tillage';
export const FILTERS_COMPONENT_CLASS = 'filters-component-class';
export const FILTERS_COMPONENT_BLOOMING = 'filters-component-blooming';
export const FILTERS_COMPONENT_MOBILE_DRAWER = 'filters-component-mobile-drawer';
export const FILTERS_COMPONENT_MOBILE_BUTTON = 'filters-component-mobile-button';
export const FILTERS_COMPONENT_MOBILE_BACK_BUTTON = 'filters-component-mobile-back-button';

export const REGIONAL_OVERVIEW_SELECT_MODEL = 'regional-overview-select-model';
export const REGIONAL_OVERVIEW_SELECT_INFO_BUTTON = 'regional-overview-select-info-button';
export const REGIONAL_OVERVIEW_INFO_MODAL_BACK_BUTTON = 'regional-overview-info-modal-back-button';

export const REGIONAL_OVERVIEW_ACTIVITY_BUTTON = 'regional-overview-activity-button';
